'use client';

import { useEffect } from 'react';

import { MIXPANEL_APP_FEATURES, mixpanelEvents } from '@/shared/constants/mixpanel-events';
import { useIdleIntercom } from '@/shared/hooks/use-intercom-widget';
import { emitMixpanelEvent } from '@/shared/utils/mixpanel-utils';

import { type MARKETING_PAGE } from '../../utils/marketing-analytics';

/**
 * Client-only side effects for the /resources roundup pages: analytics view
 * event and the Intercom widget. Rendered as a null island so the page itself
 * stays a server component. `page` tells the roundups apart from the home page,
 * which fires the same view event.
 */
export const BestFreeAtsPageEffects = ({ page }: { page: MARKETING_PAGE }) => {
	useIdleIntercom();

	useEffect(() => {
		emitMixpanelEvent(mixpanelEvents.VIEWED_LANDING_PAGE, {
			feature: MIXPANEL_APP_FEATURES.LANDING_PAGE,
			page,
		});
	}, [page]);

	return null;
};
